import CartTypes from "./cart.types";

export const SetIntarnalOrExternal = (value) =>({
    type : CartTypes.SET_INTERNAL_EXTERNAL,
    payload : value
});
export const SetPrice = (price) =>({
    type : CartTypes.SET_PRICE,
    payload : price
});
export const SetInstallation = (value) =>({
    type : CartTypes.SET_INTSTALLATION,
    payload : value
});
export const ChangePortal = (portal) =>({
    type : CartTypes.CHANGE_PORTAL,
    portal : portal
});